var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLs = function SvgLs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M0 0h450v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h450v210H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0 0h450v90H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    d: "M224.76 95.569c-1.71.037-3.378 1.93-3.378 1.93l.147 20.234-6.388 6.692h5.172l-.044 11.603-30.591 41.193-4.522-1.563-7.904 16.86s19.55 12.243 47.925 11.908c31.144-.37 48.064-12.471 48.064-12.471l-8.168-16.644-4 1.74-30.983-40.98-.043-11.949h5.17l-7.037-6.609.041-20.159s-1.751-1.82-3.46-1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 5,
    d: "M235.43 144.01h-21.153s-7.678-16.176-6.433-27.485c1.267-11.515 7.848-16.963 16.598-17.059 10.345-.115 15.767 5.07 17.405 16.598 1.623 11.424-6.417 27.947-6.417 27.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.79 182.57c-.346.461-2.882 5.533-2.882 5.533l4.38-.923zm2.53 6.57-4.61 1.498 5.532 2.19zm2.08-6.46 2.305 6.8 5.648-1.613-1.498-3.227zm3.57 9.23.807 2.766 7.492 1.845-2.997-6.34zm8.3-5.77 2.651 6.34 5.648-2.19-1.844-2.767zm3.69 8.65.922 2.42 8.76 1.268-3.688-5.763zm8.41-6.8 3.227 5.648 8.184-2.997-.922-2.19zm4.73 7.72 1.729 2.997 10.143-.346-3.804-5.648zm10.72-7.49 2.766 4.726 6.455-3.112-1.729-2.536zm10.6 3.57-6.455 3.227 1.73 2.767 8.644-1.384zm2.08-4.96 3.343 4.15 5.417-4.265-1.844-1.96zm9.91 2.19-5.187 3.919 1.383 2.42 7.147-1.844zm7.15-8.18 1.268 1.844-3.573 5.302-3.689-4.725zm2.42 4.61 2.19 4.38-4.38 1.498-.346-2.074z"
  }))));
};
export default SvgLs;